var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBenchmarks(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u0421\\u043B\\u043E\\u0439_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 25 21",
    style: {
      enableBackground: "new 0 0 25 21"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#010202;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 16,
    className: "st0",
    width: 6,
    height: 21
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 12,
    className: "st0",
    width: 6,
    height: 9
  }), /*#__PURE__*/React.createElement("rect", {
    y: 15,
    className: "st0",
    width: 6,
    height: 6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 20,
    className: "st0",
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 15,
    className: "st0",
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 10,
    className: "st0",
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 5,
    className: "st0",
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24,
    className: "st0",
    width: 1,
    height: 1
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBenchmarks);
export default __webpack_public_path__ + "static/media/benchmarks.f86fac7a833e28d009ca206eef2f5699.svg";
export { ForwardRef as ReactComponent };